import { Sheet as SheetRoot, type SheetProps } from './Sheet';
import { SheetBody } from './SheetBody';
import { SheetClose } from './SheetClose';
import { SheetDescription } from './SheetDescription';
import { SheetFooter } from './SheetFooter';
import { SheetHeader } from './SheetHeader';
import { SheetTitle } from './SheetTitle';
import { SheetTrigger } from './SheetTrigger';

export const Sheet = {
  Root: SheetRoot,
  Header: SheetHeader,
  Body: SheetBody,
  Footer: SheetFooter,
  Title: SheetTitle,
  Description: SheetDescription,
  Close: SheetClose,
  Trigger: SheetTrigger,
};

export type { SheetProps };
